module.exports = __webpack_public_path__ + "static/img/logo-white.30f0dde.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo-white.svg
// module id = 306
// module chunks = 1